import React from 'react'
import './DevelopersInfo.css'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
const DevelopersInfo = () => {
  return (
    <div>
        <Navbar/>

        <div className='developersInfo'>

            <div className='row'>
                <div className='col-md-6 developer-cont-outer'>
                    <div className='developer-container'>
                        <div className='developer-img-container'>
                            <img src="../images/adpage.webp" alt="" className='developer-img'/>
                        </div>
                        <h4>
                            Madhav Arora
                        </h4>

                        <div className='dev-content'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi laborum labore quam voluptates 
                        </div>

                        <div className='developer-footer'>
                            <div className='dev-social'>
                                <div>- Backend</div>
                            </div>
                            <div className='dev-social dev-social-link'>
                                <i className="fa-brands fa-linkedin" style={{fontSize:'larger'}}></i>
                                <div>@Madhav</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 developer-cont-outer'>
                    <div className='developer-container'>
                        <div className='developer-img-container'>
                            <img src="../images/adpage.webp" alt="" className='developer-img'/>
                        </div>
                        <h4>
                            Prakhar Dhyani
                        </h4>

                        <div className='dev-content'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi laborum labore quam voluptates saepe error tempore, quasi, quos iusto 
                        </div>

                        <div className='developer-footer'>
                            <div className='dev-social'>
                                <div>- Frontend</div>
                            </div>
                            <div className='dev-social dev-social-link'>
                                <i className="fa-brands fa-linkedin" style={{fontSize:'larger'}}></i>
                                <div>@Prakhar</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 developer-cont-outer'>
                    <div className='developer-container'>
                        <div className='developer-img-container'>
                            <img src="../images/adpage.webp" alt="" className='developer-img'/>
                        </div>
                        <h4>
                            Aditya Negi
                        </h4>

                        <div className='dev-content'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi laborum labore quam voluptates saepe error tempore, quasi, 
                        </div>

                        <div className='developer-footer'>
                            <div className='dev-social'>
                                <div>- Frontend</div>
                            </div>
                            <div className='dev-social dev-social-link'>
                                <i className="fa-brands fa-linkedin" style={{fontSize:'larger'}}></i>
                                <div>@Aditya</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 developer-cont-outer'>
                    <div className='developer-container'>
                        <div className='developer-img-container'>
                            <img src="../images/adpage.webp" alt="" className='developer-img'/>
                        </div>
                        <h4>
                            Kshitiz
                        </h4>

                        <div className='dev-content'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi laborum labore quam voluptates saepe error tempore, quasi, quos iusto repellat corrupti pariatur? Nihil error expedita
                        </div>

                        <div className='developer-footer'>
                            <div className='dev-social'>
                                <div>- Backend</div>
                            </div>
                            <div className='dev-social dev-social-link'>
                                <i className="fa-brands fa-linkedin" style={{fontSize:'larger'}}></i>
                                <div>@Kshitiz</div>
                            </div>
                        </div>
                    </div>
                </div>
                
               
                
            </div>

        </div>


        <Footer/>
    </div>
  )
}

export default DevelopersInfo